<template>
	<div>
		<div class="flex flex-wrap fixed_box">
			<el-steps :active="0" finish-status="success" style="width:98%;" class="stepss">
				<el-step v-for="(item,index) in stepList" :key="index" style="font-size: 10px;" :status="item.status"  @click.native="step(index,true)" :description="item.description" :title="item.title">
				</el-step>

		<!--		<el-steps
				:active="active"
				finish-status="success"
				style="width: 98%"
				class="stepss"
			>
				<span class="red">*  </span>
				<el-step @click.native="step(0)" title="注册登记表"></el-step>
				<span class="red">*  </span>
				<el-step @click.native="step(1)" title="知识产权汇总表"></el-step>
				<span class="red">*  </span>
				<el-step @click.native="step(2)" title="人力资源情况表"></el-step>
				<el-step
					@click.native="step(3)"
					title="企业研发开发活动情况表"
				></el-step>
				<el-step
					@click.native="step(4)"
					title="企业年度研究开发费用结构明细表"
				></el-step>
				<el-step
					@click.native="step(5)"
					title="上年度高新技术产品(服务)情况表"
				></el-step>
				<el-step @click.native="step(6)" title="企业创新能力"></el-step>
				<el-step
					@click.native="step(7)"
					title="企业参与国家标准或行业标准制定情况汇总表"
				></el-step>
				<el-step @click.native="step(8)" title="主要情况表"></el-step>
				<span class="red">*  </span>
				<el-step @click.native="step(9)" title="申请书封皮"></el-step>
				<el-step @click.native="step(10)" title="上传附件"></el-step>-->
				<el-step @click.native="sc" title="点击生成申报材料"></el-step>
			</el-steps>
		</div>
		<!--      <div class="flex flex-wrap fixed_box">
      <el-button :type="buttonType(1)" @click="step(1)">注册登记表</el-button>
      <el-button :type="buttonType(2)" @click="step(2)">知识产权汇总表</el-button>
      <el-button :type="buttonType(3)" @click="step(3)">人力资源情况表</el-button>
      <el-button :type="buttonType(4)" @click="step(4)">企业研发开发活动情况表</el-button>
      <el-button :type="buttonType(5)" @click="step(5)">企业年度研究开发费用结构明细表</el-button>
      <el-button :type="buttonType(6)" @click="step(6)">上年度高新技术产品(服务)情况表</el-button>
      <el-button :type="buttonType(7)" @click="step(7)">企业创新能力</el-button>
      <el-button :type="buttonType(8)" @click="step(8)">企业参与国家标准或行业标准制定情况汇总表</el-button>
      <el-button :type="buttonType(9)" @click="step(9)">主要情况表</el-button>
      <el-button :type="buttonType(10)" @click="step(10)">申请书封皮</el-button>
      <el-button :type="buttonType(11)" @click="step(11)">上传附件</el-button>
      <el-button type="success" @click="sc">申报材料生成</el-button>
  &lt;!&ndash;     <router-link to="/ChinaHigh/mainConditions">
          <el-button>主要情况表</el-button>
       </router-link>&ndash;&gt;
      </div>-->

		<div style="height: 140px"></div>
		<registration-form
			v-if="active === 0"
			ref="registrationForm"
			@ok="ok"
			:id="id"
			@step="step(1)"
		/>
		<intellectual v-if="active === 1" :id="id" />
		<manpower-form v-if="active === 2" :id="id" @step="step(3)" />
		<enterprise v-if="active === 3" :id="id" />
		<structure v-if="active === 4" :id="id" />
		<serve v-if="active === 5" :id="id" />
		<innovate v-if="active === 6" :id="id" />
		<formulate v-if="active === 7" :id="id" />
		<main-conditions v-if="active === 8" @step="step(9)" :id="id" />
		<application-form v-if="active === 9" @step="step(10)" :id="id" />
		<accessory v-if="active === 10" :id="id" />
	</div>
</template>
<script>
import RegistrationForm from "@/views/form/ChinaHighRegistrationForm/modules/registrationForm";
import intellectual from "@/views/form/ChinaHighRegistrationForm/modules/intellectual";
import manpowerForm from "@/views/form/ChinaHighRegistrationForm/modules/manpowerForm";
import enterprise from "@/views/form/ChinaHighRegistrationForm/modules/enterprise";
import structure from "@/views/form/ChinaHighRegistrationForm/modules/structure";
import serve from "@/views/form/ChinaHighRegistrationForm/modules/serve";
import innovate from "@/views/form/ChinaHighRegistrationForm/modules/innovate";
import formulate from "@/views/form/ChinaHighRegistrationForm/modules/formulate";
import mainConditions from "@/views/form/ChinaHighRegistrationForm/modules/mainConditions";
import applicationForm from "@/views/form/ChinaHighRegistrationForm/modules/applicationForm";
import accessory from "@/views/form/ChinaHighRegistrationForm/modules/accessory";

import { commonSubmitGenerateApproval } from "@/api/toolCommon";
import { getPageFillInStatus } from '@/api/ChinaHigh';

export default {
	components: {
		RegistrationForm,
		intellectual,
		manpowerForm,
		enterprise,
		structure,
		serve,
		innovate,
		formulate,
		mainConditions,
		applicationForm,
		accessory
	},
	data() {
		return {
            stepList:[],
			active: 0,
			id: "",
			obj: { objectId: "", type: 1 },
            loading:false,
            enterpriseInformationRegisterStatus:'wait',
            //知识产权汇总表
            intellectualPropertyStatus:'wait',
            //人力资源情况表
            humanResourceStatus:'wait',
            //企业研发开发活动情况表
            enterpriseDevelopmentsActivitiesAccessStatus:'wait',
            //企业年度研究开发费用结构明细表
            annualCostStatus:'wait',
            //上年度高新技术产品(服务)情况表
            highTechProductStatus:'wait',
            //企业创新能力
            innovationAbilityAndAchievementStatus:'wait',
            //企业参与国家标准或行业标准制定情况汇总表
            participateInNationalStandardDesignationStatus:'wait',
            //主要情况表
            additionalInformationStatus:'wait',
            //申请书封皮
            applicationCoverStatus:'wait',
            //上传附件
            uploadAttachStatus:'wait',
            disable:false,
        };
	},
	created() {
		this.id = this.$route.query.id;
        this.fillInStatus(this.id);
	},
	methods: {
		step(index,flag) {
            this.olderStepList.forEach(item => {
                if (item.status == "process") {
                    item.status = "success"
                }
            })
            this.olderStepList[index].status = "process";
            if (flag != null) {
                if (this.id !== "" && this.id !== undefined && this.id !== null) {
                    if (
                        this.active == 0 ||
                        this.active == 2 ||
                        this.active == 6 ||
                        this.active == 8 ||
                        this.active == 9
                    ) {
                        this.$confirm(
                            "请确认当前页数据是否填写完整并保存,否则将导致数据丢失(若已保存请忽略)",
                            "确认离开吗?",
                            {type: "warning"}
                        ).then(() => {
                            this.active = index;
                            this.fillInStatus(1, index)
                        });
                    } else {
                        this.active = index;
                        this.fillInStatus(1, index)
                    }
                } else {
                    this.msgError("请先提交注册登记表");
                }
            }
            else {
                this.active = index;
                this.fillInStatus(1, index)

            }
        },
        fillInStatus(id,index){
            getPageFillInStatus(this.id).then(res=>{
                var stepList = new Array(11);
                //登记注册表
                stepList[0] = {
                    title:"登记注册表(必填)",
                    status: res.data.enterpriseInformationRegisterStatus>0 ? "success" :"wait",
                    /*description:"必填"*/
                }
                //知识产权汇总表
                stepList[1] = {
                    title:"知识产权汇总表(必填)",
                    status: res.data.intellectualPropertyStatus>0 ? "success" :"wait",
                    /*description:"必填"*/
                }
                //人力资源情况表
                stepList[2] = {
                    title:"人力资源情况表(必填)",
                    status: res.data.humanResourceStatus>0 ? "success" :"wait",
                    /*description:"必填"*/
                }
                //企业研发开发活动情况表
                stepList[3] = {
                    title:"企业研发开发活动情况表",
                    status: res.data.enterpriseDevelopmentsActivitiesAccessStatus>0 ? "success" :"wait",
                    req:false
                }
                //企业年度研究开发费用结构明细表
                stepList[4] = {
                    title:"企业年度研究开发费用结构明细表",
                    status: res.data.annualCostStatus>0 ? "success" :"wait",
                    req:false
                }
                //上年度高新技术产品(服务)情况表
                stepList[5] = {
                    title:"上年度高新技术产品",
                    status: res.data.highTechProductStatus>0 ? "success" :"wait",
                    req:false
                }
                //企业创新能力
                stepList[6] = {
                    title:"企业创新能力",
                    status: res.data.innovationAbilityAndAchievementStatus>0 ? "success" :"wait",
                    req:false
                }
                //企业参与国家标准或行业标准制定情况汇总表
                stepList[7] = {
                    title:"企业参与国家标准或行业标准制定情况汇总表",
                    status: res.data.participateInNationalStandardDesignationStatus>0 ? "success" :"wait",
                    req:false
                }
                //主要情况表
                stepList[8] = {
                    title:"主要情况表",
                    status: res.data.additionalInformationStatus>0 ? "success" :"wait",
                    req:false
                }
                //申请书封皮
                stepList[9] = {
                    title:"申请书封皮(必填)",
                    status: res.data.applicationCoverStatus>0 ? "success" :"wait",
                    /*description:"必填"*/
                }
                //上传附件
                stepList[10] = {
                    title:"上传附件",
                    status: res.data.uploadAttachStatus>0 ? "success" :"wait",
                    req:false
                }
                this.olderStepList = JSON.parse(JSON.stringify(stepList))
                if(index == null){
                    index = 0;
                }
                stepList[index].status='process';
                this.stepList = stepList;
            })
        },
		buttonType(val) {
			if (val == this.active) {
				return "primary";
			}
		},
		ok(val) {
			this.id = val;
		},
		sc() {
			this.obj.objectId = this.id;
			commonSubmitGenerateApproval(this.obj).then(res => {
				if (res.code === "00000") {
					this.$alert("提交申请成功,预计" + res.data + "后完成生成");
					this.$router.push("/centerform/ChinaHighApply");
					// }
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.flex .el-button {
	margin-bottom: 10px;
	margin-right: 10px;
}
/* .fixed_box {
	position: fixed;
	top: 60px;
	background: #f6f6f6;
	z-index: 99;
	padding-top: 20px;
} */
/deep/ .el-step__title.is-wait {
	color: black;
}
.el-step__title{
	font-size: 10px;}

</style>
<style>
	.el-step__description.is-success{
		color: red;
	}
	.el-step__description.is-wait{
		color: red;
	}
	.el-step__description.is-process{
		color: red;
	}
	.el-step__description.is-error{
		color: red;
	}
	.el-step__description.is-finish  {
		color: red;
	}
	.el-step__description {
		color: red;
	}
</style>